/**
 * Enum of user permissions
 */
export enum Permissions {
    deliveries = 'gerenciar-sms',
    contacts = 'gerenciar-contato',
    groups = 'gerenciar-grupo',
    campaigns = 'gerenciar-campanha',
    blacklist = 'gerenciar-blacklist',
    users = 'gerenciar-usuario',
    finance = 'gerenciar-financeiro',
    reports = 'gerenciar-relatorios',
    company = 'gerenciar-empresa',
    progress = 'gerenciar-progresso',
    creditCard = 'gerenciar-cartao-credito',
    buyCredit = 'gerenciar-compra-credito',
    recurrent = 'gerenciar-recorrente',
    consume = 'gerenciar-consumo',
    costReport = 'relatorio-custo',
    apiStatus = 'gerenciar-statusapi',
    plan = 'gerenciar-plano',
    price = 'gerenciar-preco',
    master = 'master',
    hide = 'hide',
    support = 'suporte',
    customer = 'perfil-cliente'
}
